import { createContext } from 'react';

import { Processor } from '@totem/components/devices/processors/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: Processor[];
  action: string;
  actionItem: Processor;
  onAction?: (action: string, item: Processor) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
